// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonMember, jsonObject } from "typedjson";

// LPSubmitSignedResponse is returned after the backend broadcasts the signed
// CKB tx. newOutpoint equals the expectedOutpoint from the init response.
@jsonObject()
export default class LPSubmitSignedResponse extends PerunMessage {
  @jsonMember(String) txHash: string;
  @jsonMember(String) newOutpoint: string;

  constructor(txHash = "", newOutpoint = "") {
    super();
    this.txHash = txHash;
    this.newOutpoint = newOutpoint;
  }

  messageType(): MessageType {
    return LPSubmitSignedResponse;
  }

  messageTypeName(): MessageTypeName {
    return "LPSubmitSignedResponse";
  }
}
